import { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { FooterNaviBar } from '../../../components/FooterNaviBar'

const STEPS = {
  STEP_PASS_NICHE_AND_OBJECTIVE: 'stepNIcheAndObjective',

  STEP_PASS_TYPOGRAPHY: 'stepTypography',

  STEP_BRANDING: 'stepBranding',
}
function StepSelectPlan({ setStep, businessAccountData }) {
  const [branding, setBranding] = useState()

  useEffect(() => {
    console.log('caindo aqui?')
  }, [])

  const handleNavigate = async (type) => {
    if (type === 'next') {
      setStep(STEPS.STEP_PASS_TYPOGRAPHY)
    } else {
      setStep(STEPS.STEP_PASS_NICHE_AND_OBJECTIVE)
    }
  }

  const { t } = useTranslation()

  return (
    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      style={{
        width: '100%',
        // height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className={styles.box_step}>
        {/* <PreviousPass steps={stepsArray}/> */}

        <div className={styles.box_page}>
          <p style={{ margin: '0px' }}>
            {t('fast_publishing_color_palette_title')}
          </p>
          <h1 style={{ marginTop: '0px', fontSize: '45px', fontWeight: 500 }}>
            {t('fast_publishing_color_palette')}
          </h1>
        </div>
        <FooterNaviBar
          back={() => handleNavigate('back')}
          next={() => handleNavigate('next')}
        />
      </div>
    </motion.div>
  )
}

export default StepSelectPlan
